import React, { useEffect, useState } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface LogoProps {
  className?: string;
  alt?: string;
  fallbackSrc?: string;
}

export function Logo({ 
  className = "h-8 w-auto", 
  alt = "Solerro",
  fallbackSrc = "/joulescrmlogo.svg"
}: LogoProps) {
  const { currentTheme } = useTheme();
  const [logoUrl, setLogoUrl] = useState(fallbackSrc);

  // Update logo when theme changes
  useEffect(() => {
    const customLogo = currentTheme.logo;
    
    if (customLogo) {
      setLogoUrl(customLogo);
    } else {
      setLogoUrl(fallbackSrc);
    }
  }, [currentTheme.logo, fallbackSrc]);

  return (
    <img
      className={`${className} dark:filter dark:invert dark:hue-rotate-180`}
      src={logoUrl}
      alt={alt}
      onError={() => setLogoUrl(fallbackSrc)}
    />
  );
} 